import { useState } from 'react';

function LazyImage({ src, alt, className, style, imgStyle }) {
    const [loaded, setLoaded] = useState(false);

    return (
        <div className={className} style={{ position: 'relative', ...style }}>
            {!loaded && (
                <div className="img-loader-overlay">
                </div>
            )}
            <img
                src={src}
                alt={alt || ''}
                onLoad={() => setLoaded(true)}
                style={{
                    opacity: loaded ? 1 : 0,
                    transition: 'opacity 0.3s ease',
                    ...imgStyle,
                }}
            />
        </div>
    );
}

export default LazyImage;
